
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import ButtonBase from '@mui/material/ButtonBase';
import Brightness5Icon from '@mui/icons-material/Brightness5';

function AppMainMyCard() {

  const handleClick = () => {
    let username = global.constants.const_default_username;
    if (JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0] === undefined ||
      JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].user_name === undefined) {
      username = 'tmp';
    } else {
      username = JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].user_name;
    }
    if (username === 'tmp') {
      window.location.href = global.constants.const_home_url + "/user/login";
    } else {
      window.location.href = global.constants.const_home_url + "/user/info"
    }
  };
  let const_username = global.constants.const_default_username;
  let status = "offline";
  if (JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0] === undefined ||
    JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].user_name === undefined) {
    const_username = 'tmp';
  } else {
    const_username = JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].user_name;
    status = JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].status;
  }

  return (
    <div >
      <Grid container spacing={0} direction="row">
        <Grid item justify="flex-start" sx={{ height: 120, width: 120 }}>
          <ButtonBase >
            <img alt="complex" height="100" width="100" src={global.constants.const_img_url + '/my-app/catalog/catalog-owner.jpg'} />
          </ButtonBase>
        </Grid>
        <Grid item xs>
          <Card>
            <CardHeader
              title={const_username}
              subheader={
                <div>
                  <Chip color={status==="online"?"success":"primary"} label={status==="online"?global.constants.const_online:global.constants.const_offline} variant="outlined"/>
                </div>
              }
            />
          </Card>
        </Grid>
        <Grid item justify="flex-end" style={{ marginRight: 0 }}>
          <IconButton aria-label="settings" onClick={() => { handleClick() }}>
            <Brightness5Icon color="primary" />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
}


export default AppMainMyCard;

